import { axios } from '../utils'

export default {
  namespaced: true,

  state: {},
  getters: {},
  actions: {
    setClients({ commit }, payload) {
      commit('SET_CLIENT', payload)
    },
    getClients({ commit }, { options, search }) {
      commit('SET_LOADING', true)
      axios
        .get(
          `api/admin/clients?page=${options.page}&itemsPerPage=${options.itemsPerPage}&search=${search}`
        )
        .then(res => {
          commit('SET_CLIENT', res.data)
          commit('SET_LOADING', false)
          console.log('done')
        })
    }
  },
  mutations: {
    SET_CLIENT(state, payload) {
      state.clients = payload
    },
    SET_LOADING(state, payload) {
      state.loading = payload
    }
  }
}
